import React, { Component } from 'react';
import { connect } from 'react-redux';
import BlockAdminMenu from '../admin/BlockAdminMenu'
import {blockTypes, blockRenderers} from '../conf/block'
import {entityFields} from '../conf/entity'
import BlockRenderer from './BlockRenderer'
import {blockExtensions} from '../conf/extensions'

class Block extends Component {
	state = {
		admin: null,
		BlockType: null,
		childs: null,
		edit: null
	}

	componentDidMount() {
		const { block} = this.props
		//console.log(block.video)
		if ((block.type==='video' || block.video)
			&& typeof(FB)!=='undefined') {
			const id = `block-${block.uuid}`
			//eslint-disable-next-line
			FB.XFBML.parse(document.getElementById(id));
		}
	}

	componentWillMount() {
		const { entity, block, tpl, edit, isEditor, isAdmin } = this.props
			if(!block) {
				this.setState({admin: null, BlockType: null, edit:null, childs:null})
				return
			}
		
			const type = block.type?block.type:'block'
			if(!blockTypes[type]) {
				console.log(`${type} not found`)
				this.setState({admin: null, BlockType: null, edit:null, childs:null})
				return
			}
			const renderEntity = tpl || entity
			this.setState({
				admin: {isEditor, isAdmin}, 
				BlockType: blockTypes[type].renderer
					?blockTypes[type].renderer
					:((block._r && blockRenderers[block._r])
						?blockRenderers[block._r]
						:BlockRenderer),
				childs: renderEntity.grid.filter(e => e.p===block.uuid)
			})
		if (isEditor && edit && edit.block===block.uuid) {
			this.setState({edit})
		}

		if(!this.state.admin || isEditor!==this.props.isEditor || isAdmin!==this.props.isAdmin) this.setState({admin: {isEditor, isAdmin}})
	}
	
	componentWillReceiveProps(nextProps) {
		const { entity, block, tpl, edit, isEditor, isAdmin } = nextProps

		if(isEditor!==this.props.isEditor || isAdmin!==this.props.isAdmin) {
			this.setState({admin: {isEditor, isAdmin}})
		}

		if(block!==this.props.block) {
			if(!block) {
				this.setState({admin: null, BlockType: null, edit:null, childs:null})
				return
			}
		
			const type = block.type?block.type:'block'
			if(!blockTypes[type]) {
				this.setState({admin: null, BlockType: null, edit:null, childs:null})
				return
			}
			const renderEntity = tpl || entity
			this.setState({
				admin: {isEditor, isAdmin}, 
				BlockType: blockTypes[type].renderer?blockTypes[type].renderer:BlockRenderer,
				childs: renderEntity.grid.filter(e => e.p===block.uuid)
			})
		}

		if(!edit && this.state.edit) this.setState({edit: null})
		if (isEditor && edit && edit.block===block.uuid) {
			this.setState({edit})
		}

	}
	
	shouldComponentUpdate(nextProps, nextState) {
		const { block, screen, isAdmin, isEditor } = nextProps
		const { edit } = nextState
		
		if(block!==this.props.block) return true
		//if(node && block.f && node!==this.props.node) return true
		if(screen!==this.props.screen) return true
		if(edit || this.state.edit) return true
		if(isAdmin !== this.state.admin.isAdmin) return true
		if(isEditor !== this.state.admin.isEditor) return true
		return true
	}

	prepareRender() {
		const {entity, block, tpl, screen} = this.props
		const {childs} = this.state
		
		let config = {
			entity, 
			block,
			childs,
			id: `block-${block.uuid}`,
			classes: [`block block-${block.type}` + (block.tag?(' '+block.tag):'')],
			style: {},
			contentClasses: ['content'],
			contentStyle: {},
			screen,
			entityFields: [],
			grid: false,
			extensions: []
		}

		if (block.ga && block.ga.trim()!=='') config.style.gridArea = block.ga
		if (block.layout && typeof block.layout==='string') config.classes.push(block.layout)

	    config.fields = (blockTypes[block.type] && blockTypes[block.type].fields)?[...blockTypes[block.type].fields]:[]

		if (block.e) {
			try {
				config.fields = config.fields.concat(JSON.parse(block.e))
			}catch(err) {
			    //eslint-disable-next-line
			    Bugsnag.notifyException(err)
				console.log(err)
			}
		}
		
		if(block.x) {
			const toks = block.x.split(',')
			toks.forEach(tok => {
				const key = tok.trim()
				if (blockExtensions[key]) config.extensions.push(blockExtensions[key])
			})
		}
		
		//config.fields = config.fields.filter(f => block[f.name])
		config.fields.forEach(f => {
			if (f.prepare) config = f.prepare(config)
			if (f.type === 'class' && block[f.name]) config.classes.push(f.name)
		})

		if(entity && block.f && block.f.trim()!=='') {
			let fieldNames = block.f.split(',')
			if(fieldNames.length!==0) {
				if (fieldNames.includes('grid') && tpl && entity.grid && entity.grid.length>0) config.grid = true
				let fieldTypes = entity.type==='node'
					?entityFields[entity.bundle]
					:entityFields[entity.type]
				if (entity.e) fieldTypes = fieldTypes.concat(JSON.parse(entity.e))
		
				config.entityFields = fieldTypes
					.filter(ft => fieldNames.includes(ft.name))
					//.filter(ft => entity[ft.name])
			}
		}
		config.entityFields.forEach(f => {
			if (f.prepare) config = f.prepare(config)
		})

		if (!config.bg && block.bg) config.bg = block.bg

		config.groups = (blockTypes[block.type] && blockTypes[block.type].groups)?blockTypes[block.type].groups:[]
		
		return config
	}

	render() {
		const { entity, block, tpl, lang } = this.props
		const {admin, BlockType, childs, edit} = this.state
		if(!block || !BlockType) return null
		
		if(block.l) {
			const langs = block.l.split(',').filter(l=>l===lang)
			if(langs.length===0) return null
		}
		
		const config = this.prepareRender()
	    //console.log(block, entity, BlockType)
		return (
			<BlockType config={config}
				entity={entity} block={block} tpl={tpl} 
				admin={admin} edit={edit} 
				menu={tpl?null:<BlockAdminMenu admin={admin} entity={entity} block={block} edit={edit}/>}
				childBlocks={childs?childs.map((item,i) => <BlockContainer key={i} entity={entity} block={item} tpl={tpl}/>):null}
			/>
		)
	}
}

function mapStateToProps(state, ownProps) {
	return {
		screen: state.screen.screen,
		lang: state.page.lang,
		edit: state.admin.edit,
		isEditor: state.auth.isEditor,
		isAdmin: state.auth.isAdmin,
	}
}

const BlockContainer = connect(mapStateToProps)(Block)
export default BlockContainer



// WEBPACK FOOTER //
// ./src/fm/block/Block.js